import * as yup from 'yup'

export const emailUpdateFormSchema = yup.object().shape({
  email: yup
    .string()
    .email('Must be a valid email address')
    .required('Email is required'),
})

export type EmailUpdateFormSchema = yup.InferType<typeof emailUpdateFormSchema>
